<!-- Modal Dialog - Login/Signup
============================================= -->
<div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content p-sm-3">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                    aria-hidden="true">&times;</span> </button>
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item"> <a id="agentlogin-tab" class="nav-link active text-abc" data-toggle="tab"
                        href="#agentlogin" role="tab" aria-controls="login" aria-selected="true">{{logintxt}}</a>
                </li>
                <!-- <li class="nav-item"> <a id="agentsignup-tab" class="nav-link text-abc" data-toggle="tab"
                        href="#agentsignup" role="tab" aria-controls="signup" aria-selected="false">{{signuptxt}}</a>
                </li> -->
            </ul>
            <div class="tab-content pt-4">
                <div class="tab-pane fade show active" id="agentlogin" role="tabpanel" aria-labelledby="login-tab">
                    <form id="agentloginForm" method="post">
                        <div class="form-group">
                            <input type="email" name="username" [(ngModel)]="username" class="form-control"
                                id="agentloginMobile" required placeholder="Mobile or Email ID">
                        </div>
                        <div class="form-group">
                            <input type="password" name="password" [(ngModel)]="password" class="form-control"
                                id="agentloginPassword" required placeholder="Password">
                        </div>
                        <div class="row mb-4">
                            <div class="col-sm text-right"> <a class="justify-content-end text-abc"
                                    (click)="forgetpassword()" href="javascript:void(0)">Forgot Password ?</a>
                            </div>
                        </div>
                        <button class="btn btn-primary btn-block" (click)="login()" type="submit">Submit</button>
                    </form>
                </div>
                <div class="tab-pane fade" id="agentsignup" role="tabpanel" aria-labelledby="signup-tab">
                    <form id="agentsignupForm" method="post">
                        <div class="form-group">
                            <input type="text" class="form-control" data-bv-field="number" [email]="true"
                                id="agentsignupEmail" name="email" [(ngModel)]="agent.email" required
                                placeholder="Email ID*">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentsignupAgency" name="agentsignupAgency"
                                [(ngModel)]="agent.agencyName" required placeholder="Company Name*">
                        </div>
                        <div class="form-group">
                            <input class="form-control" id="agentsignupPhone" name="phone" [(ngModel)]="agent.phone"
                                required placeholder="Phone Number*" type="tel" minlength="10" maxlength="10"
                                (keypress)="keyPress($event)">
                        </div>
                        <div class="form-group">
                            <input class="form-control" id="agentsignupMobile" name="agentsignupMobile"
                                [(ngModel)]="agent.mobile" required placeholder="Mobile Number*" type="tel"
                                minlength="10" maxlength="10" (keypress)="keyPress($event)">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentfName" (keypress)="onlyAlphabets($event)"
                                name="firstName" [(ngModel)]="agent.contactPerson" required placeholder="first Name*">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentlName" (keypress)="onlyAlphabets($event)"
                                name="lastName" [(ngModel)]="agent.lastName" required placeholder="last Name*">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="designation" name="designation"
                                [(ngModel)]="agent.designation" required placeholder="Designation">
                        </div>
                        <div class="form-group">
                            <input type="password" class="form-control" id="agentsignuploginPassword" name="password"
                                [(ngModel)]="agent.password" required placeholder="Password*">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentaddress" name="address"
                                [(ngModel)]="agent.address" required placeholder="Address">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentcity" name="city"
                                (keypress)="onlyAlphabets($event)" [(ngModel)]="agent.city" placeholder="City">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentstate" name="state"
                                (keypress)="onlyAlphabets($event)" [(ngModel)]="agent.state" placeholder="State">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentcountry" (keypress)="onlyAlphabets($event)"
                                name="country" [(ngModel)]="agent.country" placeholder="Country">
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" id="agentzip" name="pin" [(ngModel)]="agent.pincode"
                                placeholder="PIN code" minlength="6" maxlength="6">
                        </div>
                        <button class="btn btn-primary btn-block" (click)="register()" type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal Dialog - Login/Signup end -->